export default __webpack_public_path__ + "static/media/img-10.153b7863.png";